"use client";

import { useState } from "react";

/**
 * «Esci»: chiude la sessione e riporta alla pagina di accesso.
 *
 * Chiama l'indirizzo di `better-auth` invece di cancellare la riga a mano,
 * perché è lui che sa come si chiama il proprio cookie e come si scrive la
 * risposta che lo fa sparire dal browser. Cancellare la sessione dal database
 * e lasciare il cookie darebbe la cosa peggiore: sembra di essere dentro
 * finché non si ricarica.
 *
 * Dopo l'uscita si va all'accesso con `location.replace`: così il tasto
 * «indietro» del browser non riporta sulla pagina di prima, che sarebbe
 * comunque vuota ma sembrerebbe un ritorno dentro.
 */
export function PulsanteEsci() {
  const [inCorso, setInCorso] = useState(false);

  async function esci() {
    setInCorso(true);
    try {
      await fetch("/api/auth/sign-out", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: "{}",
      });
    } finally {
      // Anche se la chiamata fallisce si va alla pagina di accesso: da lì si
      // riprova. Restare fermi con un pulsante che gira sarebbe peggio.
      window.location.replace("/accesso");
    }
  }

  return (
    <button type="button" className="bottone-banda" onClick={esci} disabled={inCorso}>
      {inCorso ? "Esco…" : "Esci"}
    </button>
  );
}
